import React from "react";

function Imprint() {
  return (
    <div className="terms-page container" style={{ paddingTop: "100px" }}>
      <h2 className="mb-4">Imprint</h2>

      <div className="terms-item mb-3">
        <strong>Company Name:</strong>
        <p>House of Berechet Studio L.L.C.</p>
      </div>

      <div className="terms-item mb-3">
        <strong>Registered Address:</strong>
        <p>
          Rr. Ukshin Hoti, Prime 2,
          <br />
          10000 Prishtina, Kosovo
        </p>
      </div>

      <div className="terms-item mb-3">
        <strong>Company Registration Number (NUI):</strong>
        <p>812263218</p>
      </div>

      <div className="terms-item mb-3">
        <strong>Email:</strong>
        <p>info@hobstudio.tv</p>
      </div>

      <div className="terms-item mb-3">
        <strong>Website:</strong>
        <p>www.hobstudio.tv</p>
      </div>

      <div className="terms-item mb-3">
        <strong>Responsible for Website Content:</strong>
        <p>House of Berechet Studio L.L.C.</p>
      </div>

      <div className="terms-item mb-3">
        <strong>Liability Note:</strong>
        <p>
          All content on this website has been prepared with the utmost care.
          However, HoB Studio accepts no responsibility for the accuracy,
          completeness, or timeliness of the content provided. Despite careful
          control of external links, HoB Studio is not responsible for the
          content of third-party websites.
        </p>
      </div>
    </div>
  );
}

export default Imprint;
